export const clamp01 = (value) => Math.min(1, Math.max(0, value));

/**
 * Linearly interpolates a list of keyframes at normalised time `t`. Each key
 * is `[t, ...values]`; the returned array holds the interpolated values.
 *
 * @param  {Array.<Array.<Number>>} keys
 * @param  {Number} t
 * @return {Array.<Number>}
 */
export const interpolate = (keys, t) => {

    let prev = keys[0];
    let next = keys[keys.length - 1];

    for (let i = 0; i < keys.length; i += 1) {

        if (keys[i][0] <= t) {
            prev = keys[i];
        }
        if (keys[i][0] >= t) {
            next = keys[i];
            break;
        }

    }

    const span = next[0] - prev[0];
    const progress = span ? (t - prev[0]) / span : 1;

    return prev.slice(1).map((value, i) => value + (next[i + 1] - value) * progress);

};

/**
 * Converts token keyframe values into the state used to draw the token on a
 * canvas: offsets as fractions of the token size, rotation in degrees and a
 * canvas filter string with an optional red glow.
 *
 * @param  {Array.<Number>} motion
 *         `[x%, y%, rotation deg]`.
 * @param  {Array.<Number>} tone
 *         `[grayscale, brightness, red glow]`.
 * @return {Object}
 */
export const tokenState = ([x, y, rotate], [gray, bright, red]) => ({
    x: x / 100,
    y: y / 100,
    rotate,
    filter: (
        `grayscale(${gray}) brightness(${bright})`
        + (red > 0.01 ? ` drop-shadow(0 0 ${8 * red}px rgb(160 0 0 / ${0.9 * red}))` : "")
    )
});
